export default "__VITE_ASSET__v79uYSot__"